import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

import { FaXTwitter, FaLinkedinIn, FaStar } from 'react-icons/fa6';

const ContactFooter = () => {


     useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section className="bg-bgDefault text-white px-5 py-10 lg:px-16 lg:py-20">
  <div className="container xl:mx-auto xl:max-w-screen-xl overflow-hidden">
    {/* Set up 12-column grid */}
    <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-10 gap-20 items-start" >
      
      {/* Left Section - span 6 cols */}

        <div className=" lg:col-span-6 space-y-6" data-aos="zoom-out-right">
          <img
            src="/techxplore-office.png"
            alt="Techxplore IT Solution, Ahmedabad Office"
            className="w-full h-auto"
          />
        </div>
        <div className=" lg:col-span-6 space-y-6 mt-10" data-aos="zoom-out-right">
          <div className="text-[60px] lg:text-heading-2 font-dmsans font-bold tracking-[-0.06em]">Contact us</div>

          <div>
            <p className="text-md text-gray-400 pb-1">Email</p>
            <p className="text-md text-body text-white border-b border-[#333] pb-2">
              connect@techxplore.io
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-400  pb-1">Phone</p>
            <p className="text-md text-body text-white border-b border-[#333] pb-2">
              +91 - 9879129867
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-400  pb-1">Social Media</p>
            <div className="flex items-center space-x-4 border-b border-[#333] pb-2 pt-2">
              <a href="#" className="text-xl hover:text-green-400">
                <FaXTwitter />
              </a>
              <a href="#" className="text-xl hover:text-green-400">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          <div>
            <p className="text-sm text-gray-400  pb-1">Registered Address</p>
            <p className="text-md text-body text-white border-b border-[#333] pb-2">
              A-1103, Infinity Tower,<br /> 
              Corporate Road,<br /> 
              Near Ramada Hotel,<br /> 
              Ahmedabad, Gujarat 380015
            </p>
          </div>
        </div>

        

      
      {/* <div className="lg:col-span-5 mt-24" data-aos="zoom-out-left">
        <div className="bg-[#242424] border border-[#2e2e2e]  lg:py-10 lg:px-10 px-5 py-5 shadow-md ">
          <h3 className="lg:text-heading-3 text-heading-4 font-dmsans font-semibold mb-3">Hire Us on Upwork</h3>
          <p className="text-[#9E9E9E] lg:text-base text-body-sm font-roboto mb-5">
            We’ve helped startups and small businesses build scalable, future-ready products 
            with speed and precision.
          </p>
            <div className="flex items-center justify-between space-x-2 mb-4">
              
              <img
                src="/platform_img/upwork_img.svg"
                alt="Upwork"
                className=" w-32 h-16 lg:w-[184px] "
              />

          
                <div className="h-10 w-px bg-gray-400 opacity-40"></div>

                      
                  <div className="flex flex-col items-center space-y-1 pr-10">
                    <div className="flex items-center space-x-1">
                      <p className="text-white text-lg font-semibold">5.0</p>
                      <span className="text-gray-400 text-body">Rating</span>
                    </div>
                    <div className="flex space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} className="text-yellow-400 text-sm" />
                      ))}
                    </div>
                  </div>

                </div>
                <button
                        type="submit"
                        className="w-full bg-[#00E599] text-black font-dmsans font-extrabold text-body lg:text-[22px] lg:leading-[100%] text-center lg:py-4 lg:px-14 px-2 py-2 hover:bg-[#00e6a1] transition"
                      >
                        Hire on Upwork
                  </button>
            </div>
        </div> */}

      </div>
  </div>
</section>
  );
};

export default ContactFooter;
